import * as React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

function FeaturedPost(props) {
  const { post } = props;

  return (
    <Grid item xs={12} md={6}>
      <CardActionArea  component="a" href={post.link}>
        <Card sx={{ display: 'flex' }}>
          <CardContent sx={{ flex: 1 }}>
            <Typography component="h1" variant="h5" dangerouslySetInnerHTML={{
                        __html: post.title
                }}>
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              By: {post.author} {post.date}
            </Typography>
            <Typography variant="subtitle1" paragraph dangerouslySetInnerHTML={{
                        __html: post.description
                }}>
            </Typography>
            {/* <Typography variant="subtitle1" color="primary">
             <Link to={post.link} className="btn btn-primary">Continue reading</Link>
            </Typography> */}
          </CardContent>
          <CardMedia
            component="img"
            sx={{
                width: 160,
                boxShadow: "0px 4px 4px 0px #00000030,inset 0 0 0 1000px rgba(0,0,0,.5)",
                display: { xs: 'none', sm: 'block' } }}
            image={post.image}
            alt={post.imageLabel}
          />
        </Card>
      </CardActionArea>
    </Grid>
  );
}

FeaturedPost.propTypes = {
  post: PropTypes.shape({
    date: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageLabel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default FeaturedPost;
